const USER_PURCHASE_ACTION={
    BUY_NOW : 'Buy now',
    ADD_TO_CART :'Add to Cart',
}

export default USER_PURCHASE_ACTION;